import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';
import { PlatformService } from '@rma/public/generic/util/environment';

/**
 * Creates a JSON header interceptor that adds RMA-specific headers to requests matching specified URL providers.
 * Each app should call this factory with only the URL providers it actually uses.
 */
export function createJsonHeaderInterceptor(urlProviderTokens: InjectionToken<() => string>[]): HttpInterceptorFn {
  return (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const platformService = inject(PlatformService);
    const rmaApiUrls = urlProviderTokens.map((token) => inject(token)());

    let headers = req.headers.set('rma.json', 'true').set('rma.tempjson', 'true');

    if (platformService.isPlatformServer) {
      headers = headers
        .set('x-internal', 'ServerSideRendering/1.0 (AWS Fargate) v31e46715-9d07-419c-9186-44cf9922743d')
        .set('User-Agent', 'ServerSideRendering/1.0 (AWS Fargate) v31e46715-9d07-419c-9186-44cf9922743d');
    }

    if (rmaApiUrls.some((url) => req.url.startsWith(url))) {
      req = req.clone({
        headers,
      });
    }
    return next(req);
  };
}
